import {FC} from "react";
import {makeStyles} from "tss-react/mui";
import {Box} from "@mui/material";
import {Route, Routes} from "react-router-dom";
import {AdminLessonsList} from "./AdminLessonsList";
import {AdminLessonLandingPage} from "./AdminLessonLandingPage";
import {AdminLessonPage} from "./AdminLessonPage";

const useStyles = makeStyles()((_theme) => ({
	adminLessonsPage: {}
}));

/**
 * Admin Lessons Page (App2)
 *
 * Routes for standalone lesson management under /admin/lessons/*
 */
export const AdminLessonsPage: FC = () => {
	const {classes} = useStyles();

	return (
		<Box className={classes.adminLessonsPage}>
			<Routes>
				<Route index element={<AdminLessonsList />} />
				<Route path="create-new" element={<AdminLessonPage />} />
				<Route path=":lessonId" element={<AdminLessonLandingPage />} />
				<Route path=":lessonId/edit" element={<AdminLessonPage />} />
				<Route path=":lessonId/edit-new" element={<AdminLessonPage />} />
			</Routes>
		</Box>
	);
};
